import styles from "./FormField.module.scss";

function FormField({
  label,
  name,
  error,
  status,
  hint,
  requiredField = true,
  placeholder,
  as = "input",
  className = "",
  ...props
}) {
  const id = `field-${name}`;
  const errorId = `${id}-error`;
  const Component = as;

  return (
    <div className={`${styles.field} ${status ? styles[status] : ""} ${className}`}>
      <label className="srOnly" htmlFor={id}>{label}</label>
      <Component
        id={id}
        name={name}
        placeholder={placeholder || label}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? errorId : undefined}
        {...props}
      />
      <div className={styles.description}>
        {requiredField ? <span className={styles.asterisk} aria-hidden="true">*</span> : null}
        {error ? (
          <span id={errorId} className={styles.error} role="alert">{error}</span>
        ) : hint ? <span className={styles.hint}>{hint}</span> : null}
      </div>
    </div>
  );
}

export default FormField;
